/** 当前臻有钱新项目路由枚举值映射 */
export enum NewVersionEnum {
  /** 贷超 */
  LOAN_MARKET = 'loan-market',
  /** 授信半流程结果页 */
  HALF_PROCESS_RESULT = 'half-process-result',
  /** 贷超半流程授信失败页 */
  HALF_PROCESS_FAILED = 'half-process-failed',
  /** 帮助中心 */
  HELPER_CENTER = 'helper-center',
  /** 意见反馈 */
  FEEDBACK = 'feedback',
  /** 我的账单 */
  RepayBills = 'repay-bills',
  /** 待还款账单 */
  RepaymentBills = 'repayment-bills',
  /** 还款计划（还款账单列表） */
  RepayPlans = 'repay-plans',
  /** 还款计划（新流程页面） */
  RepaymentPlan = 'repayment-plan',
  /** 提前结清订单列表（待还款列表） */
  RepaySettleList = 'repay-settle-list',
  /** 总待还账单（总待还详情） */
  RepaySummary = 'repay-summary',
  /** 还款 */
  Repay = 'repay',
  /** 还款记录 */
  RepayRecords = 'repay-records',
  /** 还款结果-申请中 */
  RepayProcessing = 'repay-processing',
  /** 还款结果-成功 */
  RepaySucceeded = 'repay-succeeded',
  /** 还款结果-失败 */
  RepayFailed = 'repay-failed',
  /** 还款详情 */
  RepayDetail = 'repay-detail',
  /** 注销账号 */
  SECURITY = 'security',
  /** 授信结果页 */
  CREDIT_RESULT = 'credit-result',
  /** 营销设置页 */
  MARKETING_SETTINGS = 'marketing-settings',
  /** 提额专区页 */
  INCREASE_CREDIT_ZONE = 'increase-credit-zone',
  /** 结清证明页 */
  CONTRACT_PREVIEW = 'contract-preview',
  /** 结清证明列表 */
  ContractSettleList = 'contract-settle-list',
  /** 注销再注册 */
  REGISTER_SMS = 'register-sms',
  /** 红包明细 */
  REPAYMENT_BONUS_LIST = 'repayment-bonus-list',
  /** 小程序说明页(不支持等场景) */
  MINI_PROGRAMS_PROMPT ='mini-programs-prompt',
  /** 分期商城首页 */
  INSTALLMENT_MALL_HOME = 'installment-mall-home',
  /** 分期商城订单 */
  INSTALLMENT_MALL_ORDER = 'installment-mall-order',
  /** 分期商城账单 */
  INSTALLMENT_MALL_BILL = 'installment-mall-bill',
  /** 分期商城授信订单 */
  INSTALLMENT_MALL_CREDIT_ORDER = 'installment-mall-credit-order',
}
